export default class ClaimBatchRequestDto {
    constructor() {
        this.xxx = "";
        this._6AmountEmergency = 0;
        this._6AmountNonEmergency = 0;
        this._6Emergency = "";
        this._6NonEmergency = "";
        this._7Transport = "";
        this._7Hospital = "";
        this._7Icu = "";
        this._7Other = "";
        this._7OtherText = "";
        this._7IcdCode1 = "";
        this._7IcdCode2 = "";
        this._7IcdCode3 = "";
        this._7IcdCode4 = "";
        this._7IcdCode5 = "";
        this._7IcdCode6 = "";
        this._7IcdCode7 = "";
        this._7IcdCode8 = "";
        this._7IcdCode9 = "";
        this._7IcdCode10 = "";
        this._7IcdCode11 = "";
        this._7IcdCode12 = "";
        this._7TreatmentPlan1 = "";
        this._7TreatmentPlan2 = "";
        this._7TreatmentPlan3 = "";
        this._7TreatmentPlan4 = "";
        this._7TreatmentPlan5 = "";
        this._7TreatmentPlan6 = "";
        this._7TreatmentPlan7 = "";
        this._7TreatmentPlan8 = "";
        this._7TreatmentPlan9 = "";
        this._7TreatmentPlan10 = "";
        this._7TreatmentPlan11 = "";
        this._7TreatmentPlan12 = "";
        this._8Transport = "";
        this._8Hospital = "";
        this._8Other = "";
        this._8OtherText = "";
        this._8IcdCode1 = "";
        this._8IcdCode2 = "";
        this._8IcdCode3 = "";
        this._8IcdCode4 = "";
        this._8IcdCode5 = "";
        this._8IcdCode6 = "";
        this._8IcdCode7 = "";
        this._8IcdCode8 = "";
        this._8IcdCode9 = "";
        this._8TreatmentPlan1 = "";
        this._8TreatmentPlan2 = "";
        this._8TreatmentPlan3 = "";
        this._8TreatmentPlan4 = "";
        this._8TreatmentPlan5 = "";
        this._8TreatmentPlan6 = "";
        this._8TreatmentPlan7 = "";
        this._8TreatmentPlan8 = "";
        this._8TreatmentPlan9 = "";
        
        this._10ProviderName0 = "";
        this._10ProviderNumber0 = "";
        this._10Admitted0 = "";
        this._10Discharged0 = "";

        this._10ProviderName1 = "";
        this._10ProviderNumber1 = "";
        this._10Admitted1 = "";
        this._10Discharged1 = "";

        this._10ProviderName2 = "";
        this._10ProviderNumber2 = "";
        this._10Admitted2 = "";
        this._10Discharged2 = "";

        this._10ProviderName3 = "";
        this._10ProviderNumber3 = "";
        this._10Admitted3 = "";
        this._10Discharged3 = "";

        this._10ProviderName4 = "";
        this._10ProviderNumber4 = "";
        this._10Admitted4 = "";
        this._10Discharged4 = "";

        this._10ProviderName5 = "";
        this._10ProviderNumber5 = "";
        this._10Admitted5 = "";
        this._10Discharged5 = "";

        this._10ProviderName6 = "";
        this._10ProviderNumber6 = "";
        this._10Admitted6 = "";
        this._10Discharged6 = "";

        this._10ProviderName7 = "";
        this._10ProviderNumber7 = "";
        this._10Admitted7 = "";
        this._10Discharged7 = "";

        this._10ProviderName8 = "";
        this._10ProviderNumber8 = "";
        this._10Admitted8 = "";
        this._10Discharged8 = "";
    }
}
